import { IHttpParams } from '../interfaces';

export const DEFAULT_PAGINATION_PARAMS: IHttpParams = {
  _count: 0,
  _offset: 0
};

export const DESCENDING_SORT = '-';

export const ARCHIVE_REQUEST_BODY = {
  name: 'status',
  value: 'retired'
};

export const CANDIDATES_STATUS_PARAM = {
  status: 'active'
};

export const DEFAULT_RESEARCH_STUDY_STATUS_PARAM = {
  status: 'active,draft'
};
